export default __webpack_public_path__ + "f4f61144eb70aeaefdcc40b692d59d35.svg";